export function normalizeConstituencyId(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-+/g, '_')
    .replace(/[^a-z0-9_]/g, '_');
}

export function getConstituencyById(records, id) {
  if (!Array.isArray(records) || !id) {
    return null;
  }

  const normalizedId = normalizeConstituencyId(id);

  return records.find((record) => {
    const candidateIds = [
      record?.constCode,
      record?.constCodeOld,
      record?.stateCd,
      record?.stateName,
      record?.constName,
    ];

    return candidateIds.some((candidate) => normalizeConstituencyId(candidate) === normalizedId);
  }) || null;
}

export function buildTooltipHtml(record) {
  if (!record) {
    return '';
  }

  return `
    <div class="constituency-tooltip">
      <div class="constituency-tooltip__title">${record.constName || 'Constituency'}</div>
      <div class="constituency-tooltip__meta">${record.stateName || 'State'}</div>
      <div class="constituency-tooltip__meta">${record.stateCd || ''}</div>
      <div class="constituency-tooltip__meta">${record.constCode || record.constCodeOld || ''}</div>
      <div class="constituency-tooltip__meta">Constituency ID: ${record.constId ?? ''}</div>
    </div>
  `;
}
